import styled from "styled-components";

export const CheckboxTitle = styled.h2`
  font-weight: 500;
  font-size: 26px;
  line-height: 16px;
  margin-bottom: 20px;
`;

export const CheckboxText = styled.p`
  font-weight: 500;
  font-size: 18px;
  line-height: 16px;
  color: var(--color);
  margin-bottom: 40px;
`;

export const CheckboxList = styled.ul`
  list-style-type: circle;
  margin-bottom: 50px;
`;

export const BasicWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
